import { animate, style, transition, trigger, state } from '@angular/animations';

export let animMaskAnimation = trigger('animMask', [
    state('true', style({opacity: 1})),
    state('false', style({opacity: 0})),
    transition('* => *', animate('300ms ease-out'))
])

